import React from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Tooltip } from 'antd';

// svgs
import { ReactComponent as IconAddOutlined } from '../../images/add-outline.svg';
import { ReactComponent as IconUpload } from '../../images/upload.svg';

// components, keys, and utils
import { BrowseDataProductFilters } from '../entity/shared/containers/profile/FilterOptions/FilterOptions';
import FilterDropdown from '../entity/shared/components/FilterDropdown/FilterDropdown';

// generated
import { DataDataProductTable } from './BrowseDataProductTableType';
import { FilterOperator, Maybe } from '../../types.generated';
import { useTranslation } from '../../i18n/useTranslation';

export interface BrowseDataProductHeaderProps {
    onAddDataProduct?: () => void;
    onImportDataProduct?: () => void;
    data: DataDataProductTable[];
    onResetFilter?: (key: string) => void;
    onApplyFilter?: (key: string, value: string | number, condition?: Maybe<FilterOperator>, negated?: boolean) => void;
    onSearch?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    canCreate?: boolean;
    canBulkImport?: boolean;
}

export const BrowseDataProductHeader: React.FC<BrowseDataProductHeaderProps> = ({
    onImportDataProduct,
    onAddDataProduct,
    onResetFilter,
    onApplyFilter,
    data,
    onSearch,
    canCreate = true,
    canBulkImport = true,
}: BrowseDataProductHeaderProps) => {
    const { t } = useTranslation();
    const unauthorizedTooltip = t('UNAUTHORISED_TOOLTIP');

    return (
        <>
            <Row gutter={8} className="px-3 pt-3 mx-0">
                <Col flex="auto">
                    <Input
                        size="middle"
                        placeholder={t('SEARCH_BY_NAME_OR_DESCRIPTION_PLACEHOLDER')}
                        prefix={<SearchOutlined />}
                        onChange={onSearch}
                    />
                </Col>
                <Col flex="none">
                    <Tooltip
                        title={!canBulkImport ? unauthorizedTooltip : undefined}
                        overlayClassName="f-tooltip-white"
                    >
                        <span>
                            <Button
                                type="text"
                                className="f-btn-flat"
                                onClick={onImportDataProduct}
                                disabled={!canBulkImport}
                            >
                                <IconUpload />
                                <span>{t('Import')}</span>
                            </Button>
                        </span>
                    </Tooltip>
                </Col>
                <Col flex="none">
                    <Tooltip title={!canCreate ? unauthorizedTooltip : undefined} overlayClassName="f-tooltip-white">
                        <span>
                            <Button type="text" className="f-btn-flat" onClick={onAddDataProduct} disabled={!canCreate}>
                                <IconAddOutlined />
                                <span>{t('Add Data Product')}</span>
                            </Button>
                        </span>
                    </Tooltip>
                </Col>
            </Row>
            <Space className="px-2 py-3 f-layout-wrap-xs" size="small">
                {BrowseDataProductFilters.map((item) => (
                    <FilterDropdown
                        {...item}
                        key={item.id}
                        disabled={!data}
                        onApplyFilter={onApplyFilter}
                        onResetFilter={onResetFilter}
                    />
                ))}
            </Space>
        </>
    );
};
